module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-solid bg-green-gradient"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-black"
  }, [_c('row', [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("Task #1")]), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("90%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    staticStyle: {
      "width": "90%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("Task #2")]), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("70%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    staticStyle: {
      "width": "70%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("Task #3")]), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("60%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    staticStyle: {
      "width": "60%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("Task #4")]), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("40%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    staticStyle: {
      "width": "40%"
    }
  })])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Calendar")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right box-tools"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Add new event")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Clear events")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View calendar")])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body no-padding"
  }, [_c('div', {
    staticClass: "id-calendar",
    staticStyle: {
      "width": "100%"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32e34547!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VACalendar.vue
// module id = 689
// module chunks = 0